import { createRequestActionTypes } from '../../helpers'

export const FETCH_VIDEOS = createRequestActionTypes('VIDEOS', 'VIDEOS')



// WEBPACK FOOTER //
// ./src/containers/Videos/constants.js